"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var React = require("react");
var isVerticallyCentered = function (layout) { return _.has(layout, ['docked', 'vCenter']); };
var isHorizontallyStretched = function (layout) { return layout && layout.docked && (layout.docked.left && layout.docked.right); };
var isVerticallyStretched = function (layout) { return Boolean(layout && layout.docked && (layout.docked.bottom && layout.docked.top)); };
var isVerticallyDocked = function (layout) { return layout && layout.docked && (layout.docked.vCenter || layout.docked.bottom || layout.docked.top); };
var isHorizontallyDocked = function (layout) { return layout && layout.docked && (layout.docked.hCenter || layout.docked.left || layout.docked.right); };
var isFixedPinnedLayout = function (layout) { return _.get(layout, 'isFixed', false) === true; };
var setVerticalMargins = function (layout) { return _.assign({}, getDockMargin(layout, 'top'), getDockMargin(layout, 'bottom')); };
var setHorizontalMargins = function (layout) { return _.assign({}, getDockMargin(layout, 'left'), getDockMargin(layout, 'right')); };
var getDockMargin = function (layout, direction) {
    var _a;
    var dockMarginValue = _.get(layout, "docked." + direction + ".px", null);
    if (_.isNumber(dockMarginValue)) {
        return _a = {}, _a["margin-" + direction] = px(dockMarginValue), _a;
    }
    return null;
};
var px = function (units) { return units + "px"; };
exports.getPinnedDockedStyle = function (layout, ie) {
    var dockedStyle = {};
    var justifySelf = ie ? '-ms-grid-column-align' : 'justify-self';
    var alignSelf = ie ? '-ms-grid-row-align' : 'align-self';
    if (isFixedPinnedLayout(layout)) {
        if (isHorizontallyDocked(layout)) {
            var dockedLayout = layout.docked;
            if (isHorizontallyStretched(layout)) {
                dockedStyle[justifySelf] = 'stretch';
                _.assign(dockedStyle, setHorizontalMargins(layout));
            }
            else if (dockedLayout.hCenter) {
                dockedStyle['margin-left'] = px(2 * dockedLayout.hCenter.px);
                dockedStyle[justifySelf] = 'center';
            }
            else {
                dockedStyle[justifySelf] = dockedLayout.left ? 'start' : 'end';
                _.assign(dockedStyle, setHorizontalMargins(layout));
            }
        }
        if (isVerticallyDocked(layout)) {
            var dockedLayout = layout.docked;
            if (isVerticallyStretched(layout)) {
                dockedStyle[alignSelf] = 'stretch';
                _.assign(dockedStyle, setVerticalMargins(layout));
            }
            else if (isVerticallyCentered(layout)) {
                dockedStyle['margin-top'] = px(2 * dockedLayout.vCenter.px);
                dockedStyle[alignSelf] = 'center';
            }
            else {
                dockedStyle[alignSelf] = dockedLayout.top ? 'start' : 'end';
                _.assign(dockedStyle, setVerticalMargins(layout));
            }
        }
    }
    return dockedStyle;
};
var stylePropName = function (key) { return _.head(key) === '-' ? key : _.kebabCase(key); };
exports.renderStyle = function (_a) {
    var id = _a.id, stylesMap = _a.stylesMap;
    var styleElementID = "" + id;
    return React.createElement('style', {
        key: styleElementID,
        id: styleElementID,
        dangerouslySetInnerHTML: {
            __html: "\n    " + _(stylesMap).map(function (compStyle, compId) { return "\n#" + compId + " {\n" + _(compStyle).omitBy(_.isNil).map(function (value, key) { return "    " + stylePropName(key) + ": " + value + ";"; }).join('\n') + "\n}"; }).join('\n')
        }
    });
};
//# sourceMappingURL=pinnedLayerUtil.js.map